export enum AppellationEgalimGroupEnum {
  BIO_CONVERSION,
  LABEL_ROUGE,
  AOP_AOC_IGP_STG,
  NIV_2_HVE,
  ECO_PECHE_DURABLE,
  RUP,
  COMMERCE_EQUITABLE,
  FERMIER,
  EXTERNALITES_ENV,
  PERF_ENV_APPRO_DIRECT,
  NON_EGALIM,
  PROVENANCE_FR,
  CIRCUIT_COURT,
  LOCAL
}
